import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_CAN_REFUELING } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import CanRefuelings from '../../components/Refuelings/CanRefuelings';

// Optional search params (deep-link / row-action filters); never fail validation.
const convertToRefuelingSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
  refuelingCanId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/can-refuelings/convert-to-refueling')({
  validateSearch: convertToRefuelingSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_CAN_REFUELING, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.convertToRefueling',
        suffix: 'menu.canRefuelingsOverview',
      },
    };
  },
  // Modal opened by the CanRefuelings list based on the URL.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  const { customerId, refuelingCanId } = Route.useSearch();

  return <CanRefuelings convertToRefueling={{ customerId, refuelingCanId }} />;
}
